<template>
    <EasyDataTable
    show-index
    table-class-name="customize-table"
    :headers="headers"
    :items="items"
    :rows-per-page="8"
    :hide-footer="false"
    @click-row="postURL"
    class="ma-4"
    >         
    </EasyDataTable>
</template>

<script setup lang="ts">
import { ref, Ref, onMounted }       from 'vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER, ALLHEADER } from '@/interfaces/SmartLink/Tables';
import { EQUIPAMENTS } from '@/interfaces/SmartLink/Equips';

/********************************
 *********** SERVICES ***********
 *******************************/
import { getItemsTablesGestor } from '@/services/Gestor/Gestor';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';


const headers:Ref<HEADER[]>     = ref([]);
const items: Ref<EQUIPAMENTS[]> = ref([]);
const HEADERS__PRIMARY_TABLE:ALLHEADER = {
    header : [
        { text: 'IP Address',   value: "ip",            sortable: true },
        { text: 'Nombre',       value: "name",          sortable: true },
        { text: 'Tipo',         value: "tipo",          sortable: true },
        { text: 'Subitpo',      value: "subtipo",       sortable: true },
        { text: 'Mark',         value: "marca",         sortable: true },
    ]
};
headers.value = HEADERS__PRIMARY_TABLE['header'];

const getItems = async() => {

    const allData = await getItemsTablesGestor()

    if( allData.status === 400 ){
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        items.value = allData.data
    }

}

const postURL = (item: EQUIPAMENTS) => {
    window.open(`http://${item.ip}/webfig/#interfaces`, "_blank", "noopener,noreferrer");
}

onMounted(() => {
    getItems()  
})
</script>